import Injector from 'vue-inject';
import Debug from '@/util/debug';
import moment from 'moment-timezone';
import { setManifest } from '@/util/sw-messages';

const debug = Debug('service:PublicConfigService');

const defaultConfig = {
  design: {},
};

export default class PublicConfigService {
  constructor(adApiService, titleService) {
    this.adApiService = adApiService;
    this.titleService = titleService;
    this.config = null;
    this.error = null;
  }

  loadConfigFromApi() {
    debug.info('loadConfigFromApi');

    return this.adApiService.getPublicConfig()
      .then(config => Object.assign(defaultConfig, config)) // force config.design to exist
      .then(config => this.config = config)
      .then(config => {
        this.titleService.setTitle(config.agent.title);
        if (config.timezone) {
          moment.tz.setDefault(config.timezone);
        }
        // TODO this should be moved somewhere else perhaps?
        const themeColor = (config.agent.design && config.agent.design.colors && config.agent.design.colors['color-primary']) || 'green';
        const backgroundColor = (config.agent.design && config.agent.design.colors && config.agent.design.colors['color-secondary']) || 'blue';
        setManifest({
          name: config.agent.title || '',
          short_name: 'Agent',
          start_url: '/',
          theme_color: themeColor,
          background_color: backgroundColor,
          display: 'fullscreen',
          icons: config.agent_manifest_icons || [{
            src: 'https://placehold.it/256x256',
            sizes: '48x48 72x72 96x96 128x128 192x192 256x256 384x384 512x512',
            type: 'image/png',
          }],
        }).catch(e => debug.warn('ignored', e));

        return config;
      })
      .catch(err => {
        debug.error('error while loading from api: %o', err);
        this.error = err;
        throw err;
      });
  }

  getConfig() {
    debug.info('getConfig err: %o, config: %o', this.error, this.config);
    if (this.error !== null) {
      return new Promise((resolve, reject) => reject(this.error));
    } else if (this.config) {
      return new Promise(resolve => resolve(this.config));
    }

    return this.loadConfigFromApi();
  }
}

Injector.service('publicConfigService', ['adApiService', 'titleService'], PublicConfigService);



// WEBPACK FOOTER //
// ./src/services/PublicConfigService.js